import { useEffect } from 'react';
import { useAppConfig } from '../../hooks/app-config';

export default function () {
  const appConfig = useAppConfig();

  useEffect(() => {
    if (appConfig.isLocalDev) {
      return;
    }

    const script = document.createElement('script');
    script.src = appConfig.platformHeaderScriptUrl;
    script.crossOrigin = 'use-credentials';
    script.type = 'text/javascript';
    // script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
